// extracted by mini-css-extract-plugin
module.exports = {"agentsPerformanceTable":"agentsPerformanceTable_agentsPerformanceTable__cQxCY"};